import React, { useMemo } from "react";
import Chart from "@/components/Chart";
export default function ({ name,data,type}) {
    const legendData = [];
    const seriesData = [];
    const selected = {};
    const unit = (type=="count"?"张":"元")
    data.forEach((item, idx) => {
      legendData.push(item.name);
      seriesData.push({
        name: item.name,
        value: item.value,
      });
      selected[item.name] = idx < 10
    });
  
    return (
      <Chart
        option={{
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c}"+unit+" ({d}%)",
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            bottom: 20,
            data: legendData,
            selected: selected,
          },
          series: [
            {
              name: name,
              type: "pie",
              radius: "55%",
              center: ["40%", "50%"],
              data: seriesData,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        }}
      />
    );
  }
  